import React from 'react';
import { Navbar } from '../../components';
import { CcdsHeader } from '../../containers';

const Ccds = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <CcdsHeader />
        </div>
    </div>
  )
}

export default Ccds